export default __webpack_public_path__ + "static/media/integrationSetup.b8558e12.png";